import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CalendarPointIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.28 18.54H3.72V5.38H20.28V18.54ZM18.64 16.9V9.86H5.36V16.9H18.64ZM14.8 15.18C13.8 15.18 13 14.38 13 13.38C13 12.38 13.8 11.58 14.8 11.58C15.8 11.58 16.6 12.38 16.6 13.38C16.6 14.38 15.8 15.18 14.8 15.18Z" />
    </SvgIcon>
  );
});
